import * as React from 'react';
import Slider from 'react-slick';

const ProxySelectorSlick = ({ sliderRef, children, settings }) => {

    return (
        <Slider ref={sliderRef}
            {...settings}
        >
            {children}
        </Slider>


    );
}


export default ProxySelectorSlick;
